export const validFileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const associationOptions = [
  {
    label: 'Item 1',
    value: 'Item 1 Value',
  },
  {
    label: 'Item 2',
    value: 'Item 2 Value',
    selected: false,
  },
  {
    label: 'Item 3',
    value: 'Item 3 Value',
  },
  {
    label: 'Item 4',
    value: 'Item 4 Value',
  },
];
